import { render, staticRenderFns } from "./updateProfileSetting2.vue?vue&type=template&id=122bf064&lang=pug"
import script from "./updateProfileSetting2.vue?vue&type=script&lang=js"
export * from "./updateProfileSetting2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports